
import "./AllClients.css";
import React from "react";
import ReactModal from "react-modal";
import { cancelation } from "../../api";
import { radioType } from "../../interfaces";

type PropsType = {
    openCancel: boolean,
    setOpenCancel: (open: boolean) => void,
    concretClient: any,
    setConcretClient: React.Dispatch<React.SetStateAction<any>>,
    reasonsType: radioType[],
    gettingClients: () => Promise<void>,
    setActivePage: React.Dispatch<React.SetStateAction<number>>,
    otherType: string
    setOtherType: React.Dispatch<React.SetStateAction<string>>
}

function Cancelation({ openCancel, setOpenCancel, concretClient, setConcretClient, reasonsType, gettingClients, setActivePage, otherType }: PropsType) {

    const closeWindow = (): void => {
        setConcretClient(null);
        setOpenCancel(false);
    }

    const cancelClient = async (): Promise<void> => {
        const cancelType = reasonsType.find(item => item.active)?.title;
        const requestData = {
            clientId: concretClient.id,
            cancellationReason: concretClient.active ? "" : cancelType,
            cancellationOtherText: cancelType === 'Other' ? otherType : ''
        }

        try {
            const responsetData = await cancelation(requestData);
            if (responsetData) {
                await gettingClients();
                setActivePage(1);
                closeWindow();
            }
        }
        catch (err) {
            console.log(err);
        }
    }

    return(
        <ReactModal
            isOpen = { openCancel }
            onRequestClose = { () => closeWindow() }
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    zIndex: 300,
                },
                content: {
                    width: "80%",
                    maxWidth: '550px',
                    maxHeight: "240px",
                    height: "55vh",
                    border: 'none',
                    margin: "auto",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: "center",
                    justifyContent: "space-evenly",
                }
            }}
        >
            <div className = 'modal-deleteClient-content'>
                {
                    !concretClient.active ? " Do You Want to Cancel this Client?" :  "Do You Want to Activate this Client?"
                }
            </div>
            <p className = "concretClienFullName">
                { concretClient.firstName + " " + concretClient.lastName }
            </p>
            <div className = 'modal-deleteClient-actions'>
                <button
                    className = "rejectAction"
                    onClick = { closeWindow }
                >
                    No
                </button>
                <button
                    className = "confirmAction"
                    onClick = { cancelClient }
                >
                    Yes
                </button>
            </div>
        </ReactModal>
    )
}

export default Cancelation
